import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'app-svg-icon',
  templateUrl: './svg-icon.component.html',
  styles: `
    :host {
      display: flex;
      justify-content: center;
      align-items: center;
      vertical-align: middle;

      svg-icon {
        display: block;
        font-size: 0;
      }
    }
  `,
  imports: [AngularSvgIconModule, CommonModule],
})
export class SvgIconComponent implements OnInit, OnChanges {
  @Input() public iconName!: string;
  @Input() public class!: string;
  @Input() public svgStyle!: Record<string, number | string>;
  @Input() public svgClass!: string;
  @Input() public iconSize!: number; //rem
  @Input() public strokeWidth!: number;
  public readonly svgFolder: string;

  public get iconPath(): string {
    return `${this.svgFolder}${this.iconName}.svg`;
  }

  constructor() {
    this.svgFolder = '/assets/custom-icons/';
    this.iconSize = 1.125;
    this.strokeWidth = 2;
    this.svgStyle = {};
  }

  public ngOnInit(): void {
    this.svgStyle['width.px'] = this.iconSize;
    this.svgStyle['height.px'] = this.iconSize;
    this.svgStyle['stroke-width'] = this.strokeWidth;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['svgStyle']?.currentValue) {
      this.svgStyle = changes['svgStyle'].currentValue;
      this.svgStyle['width.px'] = this.iconSize;
      this.svgStyle['height.px'] = this.iconSize;
      this.svgStyle['stroke-width'] = this.strokeWidth;
    }
  }
}
